var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGodmode = function SvgGodmode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M14 20v-7.5h-3.75V10h10v2.5H16.5V20zM1.5 28.75v-7.5H4V8.75H1.5v-7.5H9v2.5h12.5v-2.5H29v7.5h-2.5v12.5H29v7.5h-7.5v-2.5H9v2.5zm7.5-5h12.5v-2.5H24V8.75h-2.5v-2.5H9v2.5H6.5v12.5H9zM4 6.25h2.5v-2.5H4zm20 0h2.5v-2.5H24zm0 20h2.5v-2.5H24zm-20 0h2.5v-2.5H4z"
  })));
};
export default SvgGodmode;